"use client";

import { useMemo } from "react";
import { useUser } from "@auth0/nextjs-auth0/client";

export function useAuth() {
  const { user, isLoading, error } = useUser();

  // Memoize so consumers with `user` in effect deps don't re-fire on every
  // render (a fresh object literal here previously caused fetch loops).
  const mappedUser = useMemo(
    () =>
      user
        ? {
            sub: user.sub ?? "",
            email: user.email ?? "",
            name: user.name ?? user.nickname ?? null,
            picture: user.picture ?? null,
            emailVerified: user.email_verified ?? false,
          }
        : null,
    [user],
  );

  return {
    user: mappedUser,
    isLoading,
    isAuthenticated: !!user,
    error,
  };
}
